import { useEffect, useState } from "react";
import Navbarr from "./Navbarr";
import Sidebar from "./Sidebar";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from "chart.js";
import { LuMessageCircleMore } from "react-icons/lu";
import { IoAnalyticsOutline, IoCheckmarkDoneCircle } from "react-icons/io5";
import { FaBars, FaBoxOpen, FaUsers } from "react-icons/fa";
import { db } from "./Firebase";
import dayjs from "dayjs";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export default function Dashboard() {

    function barData() {
        // Initialize counts for 12 months (Jan–Dec)
        const monthCounts = Array(12).fill(0);

        data.forEach((enquiry) => {
            if (enquiry.Date) {
                let dateObj;

                // Handle different date formats
                if (enquiry.Date.toDate) {
                    // Firebase Timestamp
                    dateObj = enquiry.Date.toDate();
                } else {
                    // Normal string or JS Date
                    dateObj = new Date(enquiry.Date);
                }

                // Only include current year
                if (dateObj.getFullYear() === new Date().getFullYear()) {
                    const month = dateObj.getMonth(); // 0 = Jan, 11 = Dec
                    monthCounts[month] += 1;
                }
            }
        });

        return {
            labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            datasets: [
                {
                    label: "Enquiries",
                    data: monthCounts,
                    backgroundColor: "#3b82f6", // Blue
                    borderRadius: 8,
                },
            ],
        };
    }

    function barOptions() {
        return {
            responsive: true,
            plugins: {
                legend: { display: true, position: "top" },
                title: {
                    display: true,
                    text: "Monthly Enquiries for Current Year",
                    font: { size: 18 },
                },
            },
            scales: {
                y: {
                    beginAtZero: true,
                    title: {
                        display: true,
                        text: "Number of Enquiries",
                    },
                },
                x: {
                    title: {
                        display: true,
                        text: "Months",
                    },
                },
            },
        };
    }

    const [products, setproducts] = useState(0);

    function fetchdataa() {
        db.collection("products").onSnapshot((snapshot) => {
            setproducts(snapshot.size);
        });
    }

    useEffect(() => {
        fetchdataa();
    }, []);

    const [data, setData] = useState([]);

    function fetchdata() {
        db.collection("mainform").onSnapshot((succ) => {
            setData(succ.docs)
        })
    }

    useEffect(() => {
        fetchdata();
    }, [])

    useEffect(() => {
        const unsubscribe = db.collection("mainform").onSnapshot((snapshot) => {
            const allData = snapshot.docs.map((doc) => ({
                id: doc.id,
                ...doc.data()
            }));
            setData(allData);
        });

        return () => unsubscribe();
    }, []);

    // Calculate yesterday's date string
    const yesterdayStr = (() => {
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        return yesterday.toISOString().split("T")[0];
    })();

    // Yesterday's data
    const yesterdayData = data.filter(item => item.Date === yesterdayStr);

    // Counts
    const distributorshipRequests = data.filter(
        (item) => item.Enquirytype === "Distributor"
    ).length;

    const yesterdayDistributorship = yesterdayData.filter(
        (item) => item.Enquirytype === "Distributor"
    ).length;

    const distributorshipChange = distributorshipRequests - yesterdayDistributorship;

    // Pending count
    const pendingCount = data.filter(item => item.Status === "Pending").length;

    // Growth calculation (monthly)
    const now = new Date();
    const thisMonth = now.getMonth();
    const lastMonth = thisMonth === 0 ? 11 : thisMonth - 1;
    const thisYear = now.getFullYear();
    const lastMonthYear = thisMonth === 0 ? thisYear - 1 : thisYear;

    const thisMonthCount = data.filter(item => {
        const d = new Date(item.Date);
        return d.getMonth() === thisMonth && d.getFullYear() === thisYear;
    }).length;

    const lastMonthCount = data.filter(item => {
        const d = new Date(item.Date);
        return d.getMonth() === lastMonth && d.getFullYear() === lastMonthYear;
    }).length;

    const growth =
        lastMonthCount > 0
            ? (((thisMonthCount - lastMonthCount) / lastMonthCount) * 100).toFixed(1)
            : 100;

    const totalEnquiries = data.length;



    const [dataas, setdataas] = useState([]);

    function fetchdata() {
        db.collection("mainform")
            .orderBy("Date", "desc") // assuming Date is a string "2025-08-12"
            .limit(5)
            .onSnapshot((succ) => {
                setdataas(succ.docs);
            });
    }

    useEffect(() => {
        fetchdata();
    }, []);



    return (
        <div className="container-fluid p-0">
            <div className="row g-0">
                <Sidebar />
                {/* Main Content */}
                <div className="col-lg-12 col-md-12 col-sm-12 col-12 ps-5" >

                    <div className="container-fluid my-2 ps-5">
                        <div className="row g-3">
                            <div className="col-md-3 carddd">
                                <div className="card shadow-sm border-0">
                                    <div className="card-body d-flex justify-content-between align-items-center">
                                        <div>
                                            <h6>Total Enquiries</h6>
                                            <h3>{totalEnquiries}</h3>
                                            {/* <p className="text-success small mb-0">+12% from last month</p> */}
                                            <p className={`small mb-0 ${growth >= 0 ? "text-success" : "text-danger"}`}>
                                                {growth >= 0 ? "+" : ""}{growth}% from last month
                                            </p>
                                        </div>
                                        <button className="btn btn-primary rounded text-light">
                                            <LuMessageCircleMore size={24} />
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3 carddd">
                                <div className="card shadow-sm border-0">
                                    <div className="card-body d-flex justify-content-between align-items-center">
                                        <div>
                                            <h6>Distributorship requests</h6>
                                            <h3>{distributorshipRequests}</h3>
                                            <p className="text-success small mb-0">
                                                {distributorshipChange >= 0 ? `+${distributorshipChange}` : distributorshipChange} from yesterday
                                            </p>
                                        </div>
                                        <button className="btn btn-danger rounded text-light">
                                            <IoAnalyticsOutline size={24} />
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3 carddd">
                                <div className="card shadow-sm border-0">
                                    <div className="card-body d-flex justify-content-between align-items-center">
                                        <div>
                                            <h6>Total Products</h6>
                                            <h3>{products}</h3>
                                            <p className="text-primary small mb-0">Live product count</p>
                                        </div>
                                        <button className="btn btn-success rounded text-light">
                                            <FaBoxOpen size={24} />
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3 carddd">
                                <div className="card shadow-sm border-0">
                                    <div className="card-body d-flex justify-content-between align-items-center">
                                        <div>
                                            <h6>Pending Approvals</h6>
                                            <h3>{pendingCount > 0 ? pendingCount : "N/A"}</h3>
                                            <p className="text-warning small mb-0">All Pending approvals</p>
                                        </div>
                                        <button className="btn btn-warning rounded text-light">
                                            <FaUsers size={24} />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Charts & Recent Enquiries */}
                        <div className="row mt-4">
                            <div className="col-md-6">
                                <div className="card shadow-sm border-0">
                                    <div className="card-body">
                                        <h6>Enquiry Trends</h6>
                                        <Bar data={barData()} options={barOptions()} />
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="card shadow-sm border-0">
                                    <h6 className="mb-3">Recent Activity</h6>
                                    <div className="card-body">
                                        {dataas.length === 0 && (
                                            <p className="text-muted small">No recent enquiries found.</p>
                                        )}

                                        {dataas.slice(0, 3).map((doc) => {
                                            const item = doc.data();
                                            return (
                                                <div className="d-flex border-start border-3 border-primary ps-3 mb-3">
                                                    <div className="w-100">
                                                        <div className="d-flex justify-content-between">
                                                            <strong>{item.Enquirytype || "New Enquiry"}</strong>
                                                            <span className="badge bg-warning text-dark">
                                                                {item.Status}
                                                            </span>
                                                        </div>
                                                        <p className="mb-0 small text-muted">{item.Businessname}</p>
                                                        <p className="mb-0 small text-muted">{item.Citystate}</p>
                                                        <small className="text-muted">
                                                            {item.Date}
                                                        </small>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                        {dataas.length > 3 && (
                                            <div className="text-muted mt-2">
                                                + {dataas.length - 3} more enquiries
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
}